module.exports = __webpack_public_path__ + "img/mail.a55d977f.svg";